(() => {
  const SELECTOR = "[data-ineffable-commissions-hero]";

  function initializeHero(section) {
    if (
      !section ||
      section.dataset.commissionsHeroInitialized === "true"
    ) {
      return;
    }

    section.dataset.commissionsHeroInitialized = "true";

    const revealSection = () => {
      section.classList.add("is-visible");
    };

    if (
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
    ) {
      revealSection();
      return;
    }

    if (!("IntersectionObserver" in window)) {
      revealSection();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          revealSection();
          observer.disconnect();
        });
      },
      {
        threshold: 0.12
      }
    );

    observer.observe(section);
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(SELECTOR)
      .forEach(initializeHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.matches?.(SELECTOR)
          ? event.target
          : event.target.querySelector?.(SELECTOR);

      if (!section) {
        return;
      }

      section.dataset.commissionsHeroInitialized =
        "false";

      initializeHero(section);
    }
  );
})();